import React from 'react';
import Projects from '../Projects/Projects';
import HeroSection from '../HeroSection/HeroSection';
import Contact from '../../Contact/Contact';

const Home = () => {

    return (
        <div className="container">
            <HeroSection></HeroSection>
            <Projects></Projects>
            <Contact></Contact>
        </div>
    );
};

export default Home;